import { PiCaretUpDownBold } from "react-icons/pi";

import { useUser } from "@shared/features/auth/hooks/useUser";
import { CardTitle } from "@shared/components/ui/card";
import { useOrganizationSwitcher } from "@shared/features/organization/hooks/useOrganizationSwitcher";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@shared/components/ui/collapsible";
import { Button } from "@shared/components/ui/Button";

import { DebugCard } from "./debug-card";
import { DebugValue } from "./debug-value";

export const DebugCardUser = () => {
  const user = useUser();
  const organizationSwitcher = useOrganizationSwitcher();

  return (
    <DebugCard className="gap-4">
      <div>
        <CardTitle className="flex gap-2 text-lg items-center px-4">
          Utilisateur
        </CardTitle>
        <DebugValue label="ID" value={user?.id} />
        <DebugValue label="Email" value={user?.username} />
        <DebugValue label="Seald ID" value={user?.sldId} />
      </div>

      <div>
        <CardTitle className="flex gap-2 text-lg items-center px-4">
          Profile
        </CardTitle>
        <DebugValue label="Type" value={user?.userType} />
        <DebugValue label="ID" value={user?.userData.id} />

        <DebugValue label="RPPS" value={user?.userData.rpps} autoHide />
        <DebugValue label="Ordoclic ID" value={user?.userData.rdclcId} autoHide />
        <DebugValue label="NIR" value={user?.userData.nir} autoHide />
      </div>

      <div>
        <CardTitle className="flex gap-2 text-lg items-center px-4">
          Organization
        </CardTitle>

        {organizationSwitcher?.organizations?.map((organization) => (
          <Collapsible
            key={organization.id}
            defaultOpen={
              organizationSwitcher.currentOrganization?.id === organization.id
            }
          >
            <CollapsibleTrigger asChild>
              <Button
                variant="ghost"
                className="flex gap-2 relative overflow-hidden w-full justify-start"
              >
                <PiCaretUpDownBold />
                {organization.name}
              </Button>
            </CollapsibleTrigger>
            <CollapsibleContent className="ml-10 border border-black/30 rounded-lg p-2">
              <DebugValue label="ID" value={organization.id} />
              <DebugValue label="Finess" value={organization.finess} />
              <DebugValue label="Siret" value={organization.siret} />
              <DebugValue label="Email" value={organization.manager.username} />
            </CollapsibleContent>
          </Collapsible>
        ))}
      </div>
    </DebugCard>
  );
};
